<form autocomplete="off" novalidate [formGroup]="ExamSemForm">
    <div *ngIf="submitButton">
        <h4 class="main-content-label mb-1"><b>
            Add New Semester Record
            </b></h4>
        <!-- <p class="text-muted card-sub-title mb-0">
            Add New Semester Information
           
        </p> -->
    </div>
    <div *ngIf="editButton">
        <h4 class="main-content-label mb-1"><b>
            Update Semester Record
            </b></h4>
        <!-- <p class="text-muted card-sub-title mb-0">
            Add New Semester Information
           
        </p> -->
    </div>
    <div class="row clearfix">
        <div  class="table-responsive mt-4">
            <table id="datatable" class="table table-bordered text-left">
                <thead>
                    <tr class="text-left">
                        <th class="f600">
                            Code
                        </th>
                        <th class="f600">
                            Name
                        </th>
                        <th class="f600">
                            Add
                        </th>
                    </tr>
                </thead>
                <tbody id="table_data" formArrayName="SemArray">
                    <!-- examSemList -->
                    <tr   *ngFor="let sem of getSemArrayControls(); let i = index; let last = last "
                    [formGroupName]="i">
                            <td>
                                <input required class="form-control input-sm"
                                formControlName="SeCode" maxlength="5">
                                <span class="red"
                                *ngIf=" errorcheck1(sem)">
                                Please Enter Valid Data
                                </span>
                                <!-- <span class="red" *ngIf="errorcheck11(sem)"> This Field Is Mandatory.</span> -->
                                <mat-error class="margin_tp"
                                *ngIf="sem.controls.SeCode.touched && sem.controls.SeCode.errors?.required">
                                   This Field is Mandatory.
                              </mat-error>
                            </td>
                            <td>
                                <input required class="form-control input-sm"
                                formControlName="SeName" maxlength="25">
                                <span class="red"
                                *ngIf=" errorcheck2(sem)">
                                Please Enter Valid Data
                                </span>
                                <mat-error class="margin_tp"
                                *ngIf="sem.controls.SeName.touched && sem.controls.SeName.errors?.required">
                                   This Field is Mandatory.
                              </mat-error>
                            </td>
                            <td class="text-center">
                                <i class="fa fa-plus a" *ngIf="last"
                                    (click)="addNewRow2(i);"></i>
                                    <i class="fa fa-minus a1" *ngIf="last"
                                    (click)="deletesemRow(i);"></i>
                                    <!-- <button mat-button mat-icon-button *ngIf="last" (click)="addNewRow2(i);" [disabled]="ExamSemForm.controls.SemArray.invalid">
                                        <img matTooltip="Add New" class="mt-1" width="25" src="../../assets/add.png"> 
                                      </button> -->
                       
                            </td>
                    </tr>
                </tbody>
            </table>
        </div>
       
        <div class="row prpl">
            <div class="col-sm-12">
                <button type="button" *ngIf="submitButton && SemesterCreate"
                class="btn size fr btn-primary btn-icon-text floatleft mt-1"
                (click)="submit()">
                <span style="display: contents; align-items: center;">
                    <img width="20vh" src="../../assets/img/save.gif"
                        style="margin-right: 5px;">
                    Save
                </span>
            </button>
            <button type="button" *ngIf="editButton && SemesterUpdate"
            class="btn size fr btn-primary btn-icon-text floatleft mt-1"
            (click)="update()">
            <span style="display: contents; align-items: center;">
                <img width="20vh" src="../../assets/img/edit1.gif"
                    style="margin-right: 5px;">
                Update
            </span>
        </button>
                <button type="button"
                class="btn fr size mar btn-primary btn-icon-text floatright mt-1"
                (click)="back()">
                <span style="display: contents; align-items: center;">
                    <img width="20vh" src="../../assets/img/turn-left.gif"
                        style="margin-right: 5px;">
                    Back
                </span>
            </button>

            </div>
           
            <!-- <button  *ngIf="submitButton" type="button" class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                 (click)="submit()">
                 Submit
            </button> -->
           
            <!-- <button type="button" *ngIf="editButton"
            class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
            (click)="update()">
                Update
            </button> -->
             <!-- <button type="button"
                class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                (click)="back()">
                Back
            </button> -->
           
        </div>
    </div>
    
</form>